import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { usePrivacyPolicyCommon } from "@/pages-react/privacy-policy/PrivacyPolicyCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

export const PrivacyPolicyMobile = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = usePrivacyPolicyCommon(props.content);

  return (
    <>
      {renderContent()}
    </>
  );
}, LayoutStyleTypes.TYPE_SM);
